export default "__VITE_ASSET__CyrlvwLy__"